import { defineMessages, FormattedMessage } from 'react-intl';

import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';
import { Typography } from '@/components/Typography';
import { paths } from '@/lib/paths';
import { INTL_PREFIX } from '@/messages/const';

export const serviceMessages = defineMessages({
  service: {
    defaultMessage: 'Service',
    id: `${INTL_PREFIX.SERVICE}.service`,
  },
  myWatchNeedAService: {
    defaultMessage: 'My watch needs a service',
    id: `${INTL_PREFIX.SERVICE}.myWatchNeedAService`,
  },
  referenceNumber: {
    defaultMessage: 'Reference number',
    id: `${INTL_PREFIX.SERVICE}.referenceNumber`,
  },
  serialNumber: {
    defaultMessage: 'Serial number',
    id: `${INTL_PREFIX.SERVICE}.serialNumber`,
  },
  skip: {
    defaultMessage: 'Skip',
    id: `${INTL_PREFIX.SERVICE}.skip`,
  },
  email: {
    defaultMessage: 'Email',
    id: `${INTL_PREFIX.SERVICE}.email`,
  },
  repairNumber: {
    defaultMessage: 'Repair number',
    id: `${INTL_PREFIX.SERVICE}.repairNumber`,
  },
  resultsForSerialNumber: {
    defaultMessage: 'Results for serial number',
    id: `${INTL_PREFIX.SERVICE}.resultsForSerialNumber`,
  },
  maximumPrices: {
    defaultMessage: 'Maximum prices',
    id: `${INTL_PREFIX.SERVICE}.maximumPrices`,
  },
  pricesVatIncl: {
    defaultMessage: 'Prices VAT incl.',
    id: `${INTL_PREFIX.SERVICE}.pricesVatIncl`,
  },
  pricesVatExcluded: {
    defaultMessage: 'Prices excl Tax',
    id: `${INTL_PREFIX.SERVICE}.pricesVatExcluded`,
  },
  pricesVatNotIncl: {
    defaultMessage: 'Prices VAT not incl.',
    id: `${INTL_PREFIX.SERVICE}.pricesVatNotIncl`,
  },
  packagingAndShippingIncluded: {
    defaultMessage: 'Packaging and shipping included',
    id: `${INTL_PREFIX.SERVICE}.packagingAndShippingIncluded`,
  },
  packagingAndShippingExcluded: {
    defaultMessage: 'Packaging and shipping excluded',
    id: `${INTL_PREFIX.SERVICE}.packagingAndShippingExcluded`,
  },
  packagingAndShippingNotIncluded: {
    defaultMessage: 'Packaging and shipping not included',
    id: `${INTL_PREFIX.SERVICE}.packagingAndShippingNotIncluded`,
  },
  onEstimate: {
    defaultMessage: 'On estimate',
    id: `${INTL_PREFIX.SERVICE}.onEstimate`,
  },
  requestAService: {
    defaultMessage: 'request a service',
    id: `${INTL_PREFIX.SERVICE}.requestAService`,
  },
  myAccount: {
    defaultMessage: 'My account',
    id: `${INTL_PREFIX.SERVICE}.myAccount`,
  },
  watchDetails: {
    defaultMessage: 'Watch details',
    id: `${INTL_PREFIX.SERVICE}.watchDetails`,
  },
  priceTableEstimate: {
    defaultMessage: 'On estimate',
    id: `${INTL_PREFIX.SERVICE}.priceTableEstimate`,
  },
  priceTablePackagingShippingNotIncluded: {
    defaultMessage: 'Packaging and shipping not included',
    id: `${INTL_PREFIX.SERVICE}.priceTablePackagingShippingNotIncluded`,
  },
  personalDetails: {
    defaultMessage: 'Personal details',
    id: `${INTL_PREFIX.SERVICE}.personalDetails`,
  },
  orderReview: {
    defaultMessage: 'Order review',
    id: `${INTL_PREFIX.SERVICE}.orderReview`,
  },
  myWatchDetail: {
    defaultMessage: 'My watch detail',
    id: `${INTL_PREFIX.SERVICE}.myWatchDetail`,
  },
  warranty: {
    defaultMessage: 'Warranty',
    id: `${INTL_PREFIX.SERVICE}.warranty`,
  },
  validUntil: {
    defaultMessage: 'Valid until',
    id: `${INTL_PREFIX.SERVICE}.validUntil`,
  },
  activated: {
    defaultMessage: 'Activated on',
    id: `${INTL_PREFIX.SERVICE}.activated`,
  },
  selectOtherWatch: {
    defaultMessage: 'Select another watch from my watches',
    id: `${INTL_PREFIX.SERVICE}.selectOtherWatch`,
  },
  orderServiceUnregistered: {
    defaultMessage:
      'I want to order a service for a watch which is not registered to My Account',
    id: `${INTL_PREFIX.SERVICE}.orderServiceUnregistered`,
  },
  comment: {
    defaultMessage: 'Comment',
    id: `${INTL_PREFIX.SERVICE}.comment`,
  },
  continueAsGuest: {
    defaultMessage: 'Continue as guest',
    id: `${INTL_PREFIX.SERVICE}.continueAsGuest`,
  },
  loginMyAccount: {
    defaultMessage: 'Log in my account',
    id: `${INTL_PREFIX.SERVICE}.loginMyAccount`,
  },
  identifyYourWatch: {
    defaultMessage: 'Identify your watch',
    id: `${INTL_PREFIX.SERVICE}.identifyYourWatch`,
  },
  selectYourWatch: {
    defaultMessage: 'Select your watch',
    id: `${INTL_PREFIX.SERVICE}.selectYourWatch`,
  },
  selectWatchToService: {
    defaultMessage: 'Please select the watch you want to service.',
    id: `${INTL_PREFIX.SERVICE}.selectWatchToService`,
  },
  notRegisteredNotShow: {
    defaultMessage:
      'If you have not registered your watch it will not show up here.',
    id: `${INTL_PREFIX.SERVICE}.notRegisteredNotShow`,
  },
  select: {
    defaultMessage: 'Select',
    id: `${INTL_PREFIX.SERVICE}.select`,
  },
  reasonWhyNeedService: {
    defaultMessage: 'Reason why my watch needs a service',
    id: `${INTL_PREFIX.SERVICE}.reasonWhyNeedService`,
  },
  asGuestTip: {
    defaultMessage:
      'Or continue as a Guest. Your repair order details will be accessible on the page “service” using your email and repair number',
    id: `${INTL_PREFIX.SERVICE}.asGuestTip`,
  },
  asGuestTipDisabled: {
    defaultMessage:
      'This watch is already registered with a Breitling account. Please log in to proceed.',
    id: `${INTL_PREFIX.SERVICE}.asGuestTipDisabled`,
  },
  loginTip: {
    defaultMessage:
      'Log in now to your Breitling Account for an easier access to your order details. If your watch is also registered to your Breitling Account, your repair order will be visible under your watch service history',
    id: `${INTL_PREFIX.SERVICE}.loginTip`,
  },
  watchRegisteredNeedLoginTip: {
    defaultMessage:
      'It seems that this watch is already registered to a Breitling Account. Just log in to your account to get easy access to your order details and make sure that your repair is visible under your watch service history',
    id: `${INTL_PREFIX.SERVICE}.watchRegisteredNeedLoginTip`,
  },
  deliveryMethod: {
    defaultMessage: 'Delivering the watch to breitling​',
    id: `${INTL_PREFIX.SERVICE}.deliveryMethod`,
  },
  sendItByMail: {
    defaultMessage: 'Send it by mail',
    id: `${INTL_PREFIX.SERVICE}.sendItByMail`,
  },
  dropOffToBoutique: {
    defaultMessage: 'Drop off to Boutique',
    id: `${INTL_PREFIX.SERVICE}.dropOffToBoutique`,
  },
  selectBox: {
    defaultMessage: 'Select a box',
    id: `${INTL_PREFIX.SERVICE}.selectBox`,
  },
  breitlingBox: {
    defaultMessage: 'Breitling box',
    id: `${INTL_PREFIX.SERVICE}.breitlingBox`,
  },
  withSpecialBox: {
    defaultMessage: 'With special shipping box',
    id: `${INTL_PREFIX.SERVICE}.withSpecialBox`,
  },
  standardShipment: {
    defaultMessage: 'Standard shipment',
    id: `${INTL_PREFIX.SERVICE}.standardShipment`,
  },
  organizeShipmentYourself: {
    defaultMessage: 'Organize shipment yourself',
    id: `${INTL_PREFIX.SERVICE}.organizeShipmentYourself`,
  },
  selectBreitlingBoxTip: {
    defaultMessage:
      'Our maintenance centre will send you a special shipping box, you can place your watch in the box with paper warranty or service booklet ( if you have ) , then send us your package.',
    id: `${INTL_PREFIX.SERVICE}.selectBreitlingBoxTip`,
  },
  selectClientBoxTip: {
    defaultMessage: 'Send your watch directly to our maintenance center.',
    id: `${INTL_PREFIX.SERVICE}.selectClientBoxTip`,
  },
  noWatchFind: {
    defaultMessage: 'No watch found',
    id: `${INTL_PREFIX.SERVICE}.noWatchFind`,
  },
  noWatchFindTip: {
    defaultMessage:
      'It seem that you have no watches registered to your Breitling Account yet. You can register your first Breitling watch by clicking the link below. Or you can also simply order a service without further watch details.',
    id: `${INTL_PREFIX.SERVICE}.noWatchFindTip`,
  },
  returnToYou: {
    defaultMessage: 'Returning the watch to you',
    id: `${INTL_PREFIX.SERVICE}.returnToYou`,
  },
  howReturnToYou: {
    defaultMessage:
      'Confirm how do you want Breitling to return your watch after the intervention is complete.',
    id: `${INTL_PREFIX.SERVICE}.howReturnToYou`,
  },
  amendSelection: {
    defaultMessage:
      'You will be able to amend your selection until the watch is ready for return',
    id: `${INTL_PREFIX.SERVICE}.amendSelection`,
  },
  boutiqueDelivery: {
    defaultMessage: 'Boutique delivery',
    id: `${INTL_PREFIX.SERVICE}.boutiqueDelivery`,
  },
  returnDetails: {
    defaultMessage: 'Return details',
    id: `${INTL_PREFIX.SERVICE}.returnDetails`,
  },
  atMyPersonalAddress: {
    defaultMessage: 'At my personal address',
    id: `${INTL_PREFIX.SERVICE}.atMyPersonalAddress`,
  },
  atMyBillingAddress: {
    defaultMessage: 'At my billing address',
    id: `${INTL_PREFIX.SERVICE}.atMyBillingAddress`,
  },
  toOtherAddress: {
    defaultMessage: 'To an other address',
    id: `${INTL_PREFIX.SERVICE}.toOtherAddress`,
  },
  selectBoutique: {
    defaultMessage: 'Select a boutique',
    id: `${INTL_PREFIX.SERVICE}.selectBoutique`,
  },
  receiveAddress: {
    defaultMessage: 'Please enter the address that you would like to receive.',
    id: `${INTL_PREFIX.SERVICE}.receiveAddress`,
  },
  sendBoxToAddress: {
    defaultMessage: 'We will send your Breitling Box to this address',
    id: `${INTL_PREFIX.SERVICE}.sendBoxToAddress`,
  },
  returnToAddress: {
    defaultMessage: 'We will return your watch to this address',
    id: `${INTL_PREFIX.SERVICE}.returnToAddress`,
  },
  autoRegisterWatch: {
    defaultMessage: 'Automatically register this watch to my Breitling account',
    id: `${INTL_PREFIX.SERVICE}.registerWatch`,
  },
  orderReceived: {
    defaultMessage: 'Order received',
    id: `${INTL_PREFIX.SERVICE}.orderReceived`,
  },
  repairOrder: {
    defaultMessage: 'Repair Order',
    id: `${INTL_PREFIX.SERVICE}.repairOrder`,
  },
  goToMyOrders: {
    defaultMessage: 'Go to my orders',
    id: `${INTL_PREFIX.SERVICE}.goToMyOrders`,
  },
  registerMyWatch: {
    defaultMessage: 'Register my watch',
    id: `${INTL_PREFIX.SERVICE}.registerMyWatch`,
  },
  noWatchInfo: {
    defaultMessage:
      'No watch information is detected, enter the serial number or select the watch from your account to identify the watch.',
    id: `${INTL_PREFIX.SERVICE}.noWatchInfo`,
  },
  loginViewMore: {
    defaultMessage:
      'Please login to your account to view more information and enjoy more services.',
    id: `${INTL_PREFIX.SERVICE}.loginViewMore`,
  },
  requestNote: {
    defaultMessage:
      'Note: After the request is sent, we will send you an estimate, and when you approve and pay the estimate in full, we will begin the intervention.',
    id: `${INTL_PREFIX.SERVICE}.requestNote`,
  },
  orderServiceForOther: {
    defaultMessage: 'I want to order a service for another watch',
    id: `${INTL_PREFIX.SERVICE}.orderServiceForOther`,
  },
  serviceHistory: {
    defaultMessage: 'My watch service history',
    id: `${INTL_PREFIX.SERVICE}.serviceHistory`,
  },
  extendMyWarranty: {
    defaultMessage: 'Extend my warranty',
    id: `${INTL_PREFIX.SERVICE}.extendMyWarranty`,
  },
  registerEnjoyMoreServices: {
    defaultMessage:
      'Your watch has not been registered yet, please register to enjoy more services.',
    id: `${INTL_PREFIX.SERVICE}.registerEnjoyMoreServices`,
  },
  maintenanceService: {
    defaultMessage: 'Maintenance service',
    id: `${INTL_PREFIX.SERVICE}.maintenanceService`,
  },
  serviceCreateDate: {
    defaultMessage: 'Service create date',
    id: `${INTL_PREFIX.SERVICE}.serviceCreateDate`,
  },
  repairNo: {
    defaultMessage: 'Repair No.',
    id: `${INTL_PREFIX.SERVICE}.repairNo`,
  },
  serviceBoutique: {
    defaultMessage: 'Service boutique',
    id: `${INTL_PREFIX.SERVICE}.serviceBoutique`,
  },
  delivery: {
    defaultMessage: 'Delivery',
    id: `${INTL_PREFIX.SERVICE}.delivery`,
  },
  deliverToBreitling: {
    defaultMessage: 'Deliver the watch to breitling',
    id: `${INTL_PREFIX.SERVICE}.deliverToBreitling`,
  },
  serviceDetails: {
    defaultMessage: 'Service details',
    id: `${INTL_PREFIX.SERVICE}.serviceDetails`,
  },
  quoteAvailable: {
    defaultMessage: 'Quote available',
    id: `${INTL_PREFIX.SERVICE}.quoteAvailable`,
  },
  waterResistanceTest: {
    defaultMessage: 'Water resistance test',
    id: `${INTL_PREFIX.SERVICE}.waterResistanceTest`,
  },
  completeService: {
    defaultMessage: 'Complete service',
    id: `${INTL_PREFIX.SERVICE}.completeService`,
  },
  customerDetails: {
    defaultMessage: 'Customer details',
    id: `${INTL_PREFIX.SERVICE}.customerDetails`,
  },
  sendByMail: {
    defaultMessage: 'Send by mail',
    id: `${INTL_PREFIX.SERVICE}.sendByMail`,
  },
  myServiceQuote: {
    defaultMessage: 'My service quote',
    id: `${INTL_PREFIX.SERVICE}.myServiceQuote`,
  },
  mandatoryDesc: {
    defaultMessage: 'Description of mandatory interventions',
    id: `${INTL_PREFIX.SERVICE}.mandatoryDesc`,
  },
  optionalDesc: {
    defaultMessage: 'Description of optional interventions',
    id: `${INTL_PREFIX.SERVICE}.optionalDesc`,
  },
  interventionLeadTime: {
    defaultMessage: 'Intervention lead time',
    id: `${INTL_PREFIX.SERVICE}.interventionLeadTime`,
  },
  mandatoryInterventions: {
    defaultMessage: 'Mandatory interventions',
    id: `${INTL_PREFIX.SERVICE}.mandatoryInterventions`,
  },
  optionalInterventions: {
    defaultMessage: 'Optional interventions',
    id: `${INTL_PREFIX.SERVICE}.optionalInterventions`,
  },
  deliveryFee: {
    defaultMessage: 'Delivery fee',
    id: `${INTL_PREFIX.SERVICE}.deliveryFee`,
  },
  salesTaxIncluded: {
    defaultMessage: 'Sales tax included',
    id: `${INTL_PREFIX.SERVICE}.salesTaxIncluded`,
  },
  total: {
    defaultMessage: 'Total',
    id: `${INTL_PREFIX.SERVICE}.total`,
  },
  agreeAndPay: {
    defaultMessage: 'Agree and pay',
    id: `${INTL_PREFIX.SERVICE}.agreeAndPay`,
  },
  decline: {
    defaultMessage: 'Decline',
    id: `${INTL_PREFIX.SERVICE}.decline`,
  },
  needHelp: {
    defaultMessage: 'Need help?',
    id: `${INTL_PREFIX.SERVICE}.needHelp`,
  },
  contactUs: {
    defaultMessage: 'Contact us',
    id: `${INTL_PREFIX.SERVICE}.contactUs`,
  },
  chatOnline: {
    defaultMessage: 'Chat online with us',
    id: `${INTL_PREFIX.SERVICE}.chatOnline`,
  },
  ambassadorReply: {
    defaultMessage: 'Our ambassador will reply to you',
    id: `${INTL_PREFIX.SERVICE}.ambassadorReply`,
  },
  immediatelyDuringBusinessHours: {
    defaultMessage: 'immediately during business hours',
    id: `${INTL_PREFIX.SERVICE}.immediatelyDuringBusinessHours`,
  },
  replyWithinBusinessDayPt1: {
    defaultMessage: 'Our Breitling Squad will reply to',
    id: `${INTL_PREFIX.SERVICE}.replyWithinBusinessDay`,
  },
  replyWithinBusinessDayPt2: {
    defaultMessage: 'you within 1 business day',
    id: `${INTL_PREFIX.SERVICE}.replyWithinBusinessDayPt2`,
  },
  contactCenter: {
    defaultMessage: 'contact center',
    id: `${INTL_PREFIX.SERVICE}.contactCenter`,
  },
  hoursWeekday: {
    defaultMessage: '{hours} (Weekday Hours)',
    id: `${INTL_PREFIX.SERVICE}.hoursWeekday`,
  },
  hoursWeekend: {
    defaultMessage: '{hours} (Weekend Hours)',
    id: `${INTL_PREFIX.SERVICE}.hoursWeekend`,
  },
  quesAboutBuy: {
    defaultMessage: 'Questions about buying',
    id: `${INTL_PREFIX.SERVICE}.quesAboutBuy`,
  },
  howLongShipping: {
    defaultMessage: 'How long is the shipping?',
    id: `${INTL_PREFIX.SERVICE}.howLongShipping`,
  },
  financingOpts: {
    defaultMessage: 'What are my financing options?',
    id: `${INTL_PREFIX.SERVICE}.financingOpts`,
  },
  chooseBandSize: {
    defaultMessage: 'Can I choose the band size?',
    id: `${INTL_PREFIX.SERVICE}.chooseBandSize`,
  },
  howMuchShipping: {
    defaultMessage: 'How much is shipping?',
    id: `${INTL_PREFIX.SERVICE}.howMuchShipping`,
  },
  cancelMyOrder: {
    defaultMessage: 'Can I cancel my order?',
    id: `${INTL_PREFIX.SERVICE}.cancelMyOrder`,
  },
  diagnosis: {
    defaultMessage: 'Diagnosis',
    id: `${INTL_PREFIX.SERVICE}.diagnosis`,
  },
  free: {
    defaultMessage: 'Free',
    id: `${INTL_PREFIX.SERVICE}.free`,
  },
  refuseReason: {
    defaultMessage: 'Reason for your refusal',
    id: `${INTL_PREFIX.SERVICE}.refuseReason`,
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: `${INTL_PREFIX.SERVICE}.cancel`,
  },
  send: {
    defaultMessage: 'Send',
    id: `${INTL_PREFIX.SERVICE}.send`,
  },
  enterReason: {
    defaultMessage: 'Enter reason',
    id: `${INTL_PREFIX.SERVICE}.enterReason`,
  },
  myServiceDetails: {
    defaultMessage: 'My service details',
    id: `${INTL_PREFIX.SERVICE}.myServiceDetails`,
  },
  watch: {
    defaultMessage: 'Watch',
    id: `${INTL_PREFIX.SERVICE}.watch`,
  },
  strap: {
    defaultMessage: 'Strap',
    id: `${INTL_PREFIX.SERVICE}.strap`,
  },
  buckle: {
    defaultMessage: 'Buckle',
    id: `${INTL_PREFIX.SERVICE}.buckle`,
  },
  bracelet: {
    defaultMessage: 'Bracelet',
    id: `${INTL_PREFIX.SERVICE}.bracelet`,
  },
  utc: {
    defaultMessage: 'Utc',
    id: `${INTL_PREFIX.SERVICE}.utc`,
  },
  other: {
    defaultMessage: 'Other',
    id: `${INTL_PREFIX.SERVICE}.other`,
  },
  variousServices: {
    defaultMessage: 'Various services',
    id: `${INTL_PREFIX.SERVICE}.variousServices`,
  },
  serviceNo: {
    defaultMessage: 'Service No.',
    id: `${INTL_PREFIX.SERVICE}.serviceNo`,
  },
  serviceQuoteDate: {
    defaultMessage: 'Date of service quote',
    id: `${INTL_PREFIX.SERVICE}.serviceQuoteDate`,
  },
  change: {
    defaultMessage: 'Change',
    id: `${INTL_PREFIX.SERVICE}.change`,
  },
  shippingAddress: {
    defaultMessage: 'Shipping address',
    id: `${INTL_PREFIX.SERVICE}.shippingAddress`,
  },
  confirm: {
    defaultMessage: 'Confirm',
    id: `${INTL_PREFIX.SERVICE}.confirm`,
  },
  billingAddress: {
    defaultMessage: 'Billing address',
    id: `${INTL_PREFIX.SERVICE}.billingAddress`,
  },
  serviceMyWatch: {
    defaultMessage: 'Service my watch',
    id: `${INTL_PREFIX.SERVICE}.serviceMyWatch`,
  },
  identifyWatchTip: {
    defaultMessage:
      'We can’t identify exactly your watch with the information provided. If you are confident the information is correct, no problem, please proceed. However, please know we won’t be able to give you any service price indication until one of our watch specialist can take a look at your Breitling watch',
    id: `${INTL_PREFIX.SERVICE}.identifyWatchTip`,
  },
  back: {
    defaultMessage: 'Back',
    id: `${INTL_PREFIX.SERVICE}.back`,
  },
  orderAService: {
    defaultMessage: 'Order a service',
    id: `${INTL_PREFIX.SERVICE}.orderAService`,
  },
  registerAWatch: {
    defaultMessage: 'Register a watch',
    id: `${INTL_PREFIX.SERVICE}.registerAWatch`,
  },
  phone: {
    defaultMessage: 'Phone',
    id: `${INTL_PREFIX.SERVICE}.phone`,
  },
  repairOrderNotFound: {
    defaultMessage: 'Repair order not found',
    id: `${INTL_PREFIX.SERVICE}.repairOrderNotFound`,
  },
  incorrectEmailAndRepairNumber: {
    defaultMessage: 'Incorrect email address or repair number',
    id: `${INTL_PREFIX.SERVICE}.incorrectEmailAndRepairNumber`,
  },
  incorrectEmailAndRepairNumberTip: {
    defaultMessage:
      'We couldn\'t match the email address and the repair number. Please check. You can also use the "Forgotten Your Repair Number" function.',
    id: `${INTL_PREFIX.SERVICE}.incorrectEmailAndRepairNumberTip`,
  },
  forgotRepairNumber: {
    defaultMessage: 'Forgotten your repair number?',
    id: `${INTL_PREFIX.SERVICE}.forgotRepairNumber`,
  },
  forgotRepairNumberTip: {
    defaultMessage:
      'Enter the e-mail address provided when the request was created.',
    id: `${INTL_PREFIX.SERVICE}.forgotRepairNumberTip`,
  },
  emailSentSuccess: {
    defaultMessage: 'Email sent to your account successfully.',
    id: `${INTL_PREFIX.SERVICE}.emailSentSuccess`,
  },
  emailSentFail: {
    defaultMessage: 'Failed to send the email.',
    id: `${INTL_PREFIX.SERVICE}.emailSentFail`,
  },
  noRepairFoundWithEmail: {
    defaultMessage: 'No repair found with this email.',
    id: `${INTL_PREFIX.SERVICE}.noRepairFoundWithEmail`,
  },
  identifySnTip: {
    defaultMessage:
      'Enter the Serial number of your Breitling watch so that we can check the best recommended service plan for your watch. You can also skip this part and continue your order a service. We will assess the interventions required when we will receive your watch in one of our service centers.',
    id: `${INTL_PREFIX.SERVICE}.identifySnTip`,
  },
  findBoutique: {
    defaultMessage: 'Find boutique',
    id: `${INTL_PREFIX.SERVICE}.findBoutique`,
  },
  serialNumberOrSku: {
    defaultMessage: 'Serial number or Model reference',
    id: `${INTL_PREFIX.SERVICE}.serialNumberOrSku`,
  },
  findSnAndRnLink: {
    defaultMessage: 'Where can find Serial number and Model reference?',
    id: `${INTL_PREFIX.SERVICE}.findSnAndRnLink`,
  },
  servicePricesResult: {
    defaultMessage: 'RESULTS FOR "{productName}"',
    id: `${INTL_PREFIX.SERVICE}.servicePricesResult`,
  },
  paymentConfirmationTitle: {
    defaultMessage: 'Thank you for confirming',
    id: `${INTL_PREFIX.SERVICE}.paymentConfirmationTitle`,
  },
  paymentConfirmationSubTitle: {
    defaultMessage:
      'Your payment order has been registered. To check the status of your service and or view a quote, visit "My Orders>Service history"in your Breitling account. As your watch is registered, the request will also appear in your watch service history.',
    id: `${INTL_PREFIX.SERVICE}.paymentConfirmationSubTitle`,
  },
  plannedDeliveryDate: {
    defaultMessage: 'Planned delivery date',
    id: `${INTL_PREFIX.SERVICE}.plannedDeliveryDate`,
  },
  watchRegistrationSuccessful: {
    defaultMessage: 'Watch registration successful',
    id: `${INTL_PREFIX.SERVICE}.watchRegistrationSuccessful`,
  },
  allMaintenanceServices: {
    defaultMessage: 'Cost of breitling maintenance services',
    id: `${INTL_PREFIX.SERVICE}.allMaintenanceServices`,
  },
  priceTableSubTitle: {
    defaultMessage:
      'Your Breitling is a precision instrument equipped with sophisticated functions. A multitude of parts in a very limited space contribute to ensure 24/7 performance. To ensure the performance of your Breitling in an optimal manner over time, it is both important and highly recomended that maintenance services be conducted periodically. We advise you to entrust your watch exclusively to a Breitling authorized service center.',
    id: `${INTL_PREFIX.SERVICE}.priceTableSubTitle`,
  },
});

export const ForgotRepairNumber = (
  <FormattedMessage
    defaultMessage='Forgotten your repair number?'
    id={`${INTL_PREFIX.SERVICE}.forgotRepairNumber`}
  />
);

export const PersonalDetails = (
  <FormattedMessage {...serviceMessages.personalDetails} />
);

const ConditionsOfServiceLink = (
  <FormattedMessage
    defaultMessage='Online customer service Terms of Conditions'
    id={`${INTL_PREFIX.SERVICE}.conditionsOfSale`}
  />
);

export const ConditionsOfService = (
  <FormattedMessage
    defaultMessage='I have read and I accept the Breitling {conditionsOfServiceLink}.'
    id={`${INTL_PREFIX.SERVICE}.conditionsOfService`}
    values={{
      conditionsOfServiceLink: (
        <LinkWithLocale href={paths.termsAndCondition.url()} target='_blank'>
          {ConditionsOfServiceLink}
        </LinkWithLocale>
      ),
    }}
  />
);

const OrderReceivedTip = (
  <FormattedMessage
    defaultMessage='Your repair order has been submitted successfully. You will be
    able to access all your repair order details directly from your
  Breitling account, under my orders. Additionally,'
    id={`${INTL_PREFIX.SERVICE}.orderReceivedTip`}
  />
);
export const RegisteredToAccount = (
  <FormattedMessage
    defaultMessage='{orderReceivedTip} as your watch is registered to your Breitling Account, the repair order will show up in your watch service history.'
    id={`${INTL_PREFIX.SERVICE}.registeredToAccount`}
    values={{
      orderReceivedTip: OrderReceivedTip,
    }}
  />
);
export const UnRegisteredToAccount = (
  <FormattedMessage
    defaultMessage='{orderReceivedTip} in order to have this repair order linked to your watch service history, we recommend you register your watch into your Breitling Account'
    id={`${INTL_PREFIX.SERVICE}.unRegisteredToAccount`}
    values={{
      orderReceivedTip: OrderReceivedTip,
    }}
  />
);

const Login = (
  <FormattedMessage
    defaultMessage='log in'
    id={`${INTL_PREFIX.SERVICE}.login`}
  />
);
const NotRegister = (
  <FormattedMessage
    defaultMessage='If not, you will still be able to access your repair details by going to “my watch needs a service” and enter your email and repair number”'
    id={`${INTL_PREFIX.SERVICE}.notRegister`}
  />
);
export const OrderReceivedTipForGuest = (
  <FormattedMessage
    defaultMessage='Your repair order has been submitted successfully. In order to access your repair order details easily, we invite you to {orderReceivedTipForGuestLink} now to your Breitling account or create one. Additionally, if you register your watch to your account, your repair will be linked to your watch service history.{notRegister}'
    id={`${INTL_PREFIX.SERVICE}.orderReceivedTipForGuest`}
    values={{
      orderReceivedTipForGuestLink: (
        <LinkWithLocale href='/my-account/login'>{Login}</LinkWithLocale>
      ),
      notRegister: <Typography>{NotRegister}</Typography>,
    }}
  />
);

export const RequestCreatedStatus = (
  <FormattedMessage
    defaultMessage='Repair request created'
    id={`${INTL_PREFIX.SERVICE}.requestCreatedStatus`}
  />
);
export const RepairBoxRequestStatus = (
  <FormattedMessage
    defaultMessage='Box requested'
    id={`${INTL_PREFIX.SERVICE}.repairBoxRequestStatus`}
  />
);
export const BoxSentStatus = (
  <FormattedMessage
    defaultMessage='Box sent'
    id={`${INTL_PREFIX.SERVICE}.boxSentStatus`}
  />
);
export const RequestTransitStatus = (
  <FormattedMessage
    defaultMessage='Waiting for your repair'
    id={`${INTL_PREFIX.SERVICE}.requestTransitStatus`}
  />
);
export const WatchReceivedStatus = (
  <FormattedMessage
    defaultMessage='Watch received'
    id={`${INTL_PREFIX.SERVICE}.watchReceivedStatus`}
  />
);
export const AnalysisStatus = (
  <FormattedMessage
    defaultMessage='Analysis'
    id={`${INTL_PREFIX.SERVICE}.analysisStatus`}
  />
);
export const EstimateSentStatus = (
  <FormattedMessage
    defaultMessage='Waiting for approval'
    id={`${INTL_PREFIX.SERVICE}.estimateSentStatus`}
  />
);
export const EstimateRefusedStatus = (
  <FormattedMessage
    defaultMessage='Estimate refused'
    id={`${INTL_PREFIX.SERVICE}.estimateRefusedStatus`}
  />
);
export const EstimateAcceptedStatus = (
  <FormattedMessage
    defaultMessage='Estimate accepted'
    id={`${INTL_PREFIX.SERVICE}.estimateAcceptedStatus`}
  />
);
export const WorkshopStatus = (
  <FormattedMessage
    defaultMessage='Repair in process'
    id={`${INTL_PREFIX.SERVICE}.workshopStatus`}
  />
);
export const WaitingPaymentStatus = (
  <FormattedMessage
    defaultMessage='Waiting for payment'
    id={`${INTL_PREFIX.SERVICE}.waitingPaymentStatus`}
  />
);
export const PaymentDoneStatus = (
  <FormattedMessage
    defaultMessage='Payment done'
    id={`${INTL_PREFIX.SERVICE}.paymentDoneStatus`}
  />
);
export const PaymentRefusedStatus = (
  <FormattedMessage
    defaultMessage='Payment refused'
    id={`${INTL_PREFIX.SERVICE}.paymentRefusedStatus`}
  />
);
export const ShippingTodoStatus = (
  <FormattedMessage
    defaultMessage='Ready for delivery'
    id={`${INTL_PREFIX.SERVICE}.shippingTodoStatus`}
  />
);
export const ShippingDoneStatus = (
  <FormattedMessage
    defaultMessage='Shipment completed'
    id={`${INTL_PREFIX.SERVICE}.shippingDoneStatus`}
  />
);
export const ShippingDoneBoutiqueStatus = (
  <FormattedMessage
    defaultMessage='In transit to boutique'
    id={`${INTL_PREFIX.SERVICE}.shippingDoneBoutiqueStatus`}
  />
);
export const PickupReadyStatus = (
  <FormattedMessage
    defaultMessage='Ready for pick-up in Boutique'
    id={`${INTL_PREFIX.SERVICE}.pickupReadyStatus`}
  />
);
export const CompletedStatus = (
  <FormattedMessage
    defaultMessage='Repair completed'
    id={`${INTL_PREFIX.SERVICE}.completedStatus`}
  />
);
